<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title">Cancellation notification</p>
          <v-icon @click="$emit('closeModal')">close</v-icon>
        </div>
        <text-editor-field 
          v-model="cancellationNotification" 
          placeholder="Label" 
          class="text-edit"
        />
      </div>
      <div class="modal-action">
        <main-button 
          depressed
          class="publish-button"
          :text="'PUBLISH ON EVENT PAGE'"
          @click="$emit('submit')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cancellation-notification-modal',
  props: {
    eventCancellationNotification: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cancellationNotification: this.eventCancellationNotification
    }
  },
  watch: {
    cancellationNotification: {
      handler(val) {
        this.$emit('values', val)
      }
    }
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  display: inline-flex;
  gap: 24px;
  padding: 24px 20px;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 0px 24px 0px rgba(51, 51, 51, 0.20);
}
.modal-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.modal-title {
  color: #0277BD;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.6px;
}
.text-edit {
  width:100%;
}
.modal-action {
  display: flex;
  margin-top: -40px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}
.publish-button {
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }
  .modal-action {
    justify-content: center;
    align-items: end;
  }
  .publish-button {
    width: 100%;
  }
}
</style>
